import { getAddToCartBody, TransformedCartResponse } from '../types/product';

// Object => Object => String => Object => Function
export const withDefaultParams = headers => options => url => body =>
  fetch(url, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...headers,
    },
    body: body.toString(),
    ...options,
  });

const addToCartHeaders = {
  'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
  'X-Requested-With': 'XMLHttpRequest',
};

// string => Function
const buildAndRequestAddToCart = url => withDefaultParams(addToCartHeaders)({ method: 'POST' })(url);

// Object => URLSearchParams
const buildAddToCartBody = formKey => product => state => new window.URLSearchParams(getAddToCartBody(formKey)(product)(state));

// Object => Object
const baseCartResponse = resp => ({
  backUrl: '',
  messages: '',
  minicart: false,
  product: {},
  ...resp,
});

// Object => Object
const transformedCartResult = (cartResponse): (TransformedCartResponse) =>
  ({
    redirectTo: cartResponse.backUrl,
    error: cartResponse.formkey_error || '',
  });

// Object => Object
const cartResponseTransform = (resp) => {
  // @todo The Magento response doesn't provide data indicating success.
  // Let's update the API to be more declarative of the result allowing us to handle
  // various cases more dynamically.
  const cartResponse = baseCartResponse(resp);
  return transformedCartResult(cartResponse);
};

// Object => Promise
export const addToCartRequest = formKey => product => state =>
  buildAndRequestAddToCart(state.product.addToCartUrl)(buildAddToCartBody(formKey)(product)(state))
    .then((resp) => {
      if (!resp.ok) {
        throw new Error(resp.statusText);
      }
 
      return resp.json().then(json => cartResponseTransform(json));
    }).catch((err) => {
      alert("Please verify recipient email is correct");
      throw err;
    });



// WEBPACK FOOTER //
// ./src/services/magento.js